import { render, staticRenderFns } from "./AddMotivo.vue?vue&type=template&id=3fc002e4&"
import script from "./AddMotivo.vue?vue&type=script&lang=js&"
export * from "./AddMotivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports